<template>
  <bids-view :override-list-configuration="listConfiguration" />
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import BidsView from "@/client/applications/justopp/views/Bids";

export default {
  name: "Bids",
  components: { BidsView },
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.bids.pageTitle",
      subTitle: "justopp.bids.pageSubtitle",
      backButton: true,
    },
  },
  meta: "justopp.bids.browserTitle",
  middleware: {
    requireUser: {},
    requireNotVendor: {},
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      listConfiguration: {
        constantFilters: {
          OwnerId: this.sg("user.profile")?.id,
        },
      },
    };
  },
};
</script>

<style></style>
